<div
    class="fixed top-0 right-0 left-0 transition-all h-auto z-[5] p-2 bg-white"
    id="navbar"
    [ngClass]="{'is-sticky': isSticky}"
>
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px]">
        <div class="menu flex items-center relative justify-content-between">
            <a class="inline-block max-w-[100px] ltr:mr-[15px] rtl:ml-[15px]">
                <img src="assets/images/logo.png" alt="logo" class="inline-block dark:hidden">
                <img src="assets/images/logo.png" alt="logo" class="hidden dark:inline-block">
            </a>
            <button
                type="button"
                id="navbar-burger-menu"
                (click)="toggleClass()"
                [class.active]="classApplied"
                class="inline-block relative leading-none lg:hidden">
                <span class="h-[3px] w-[30px] my-[5px] block bg-black dark:bg-black"></span>
                <span class="h-[3px] w-[30px] my-[5px] block bg-black dark:bg-black"></span>
                <span class="h-[3px] w-[30px] my-[5px] block bg-black dark:bg-black"></span>
            </button>
            <div class="hidden lg:flex items-center grow justify-end basis-full basis-auto">
                <ul class="navbar-nav flex justify-end ltr:ml-[30px] rtl:mr-[30px] ltr:xl:ml-[55px] rtl:xl:mr-[55px] flex-row gap-[30px] xl:gap-[50px] w-80">
                    <!-- <li>
                        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600 text-[15px] xl:text-md">
                            Home
                        </a>
                    </li> -->
                    <li>
                        <a (click)="smoothScroll('about-us')" class="nav-item cursor-pointer">
                            About Us
                        </a>
                    </li>
                    <li>
                        <a (click)="smoothScroll('mission-vision')" class="nav-item cursor-pointer">
                            Mission & Vision
                        </a>
                    </li>
                    <li>
                        <a (click)="smoothScroll('training-areas')" class="nav-item cursor-pointer">
                            Training List
                        </a>
                    </li>
                </ul>
                <div class="flex items-center ltr:ml-auto rtl:mr-auto gap-[15px]">
                    <a routerLink="/authentication" class="signin inline-block text-primary-600 lg:text-[15px] xl:text-[16px] py-[11px] px-[17px] rounded-md transition-all font-medium border border-primary-600 hover:text-white hover:bg-primary-500 hover:border-primary-500">
                        <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                            <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-[24px]">
                                login
                            </i>
                            Sign in
                        </span>
                    </a>
                    <!-- <a routerLink="/authentication/sign-up" class="inline-block lg:text-[15px] xl:text-[16px] py-[11px] px-[17px] bg-purple-600 text-white rounded-md transition-all font-medium border border-purple-600 hover:bg-purple-500 hover:border-purple-500">
                        <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                            <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-[24px]">
                                person
                            </i>
                            Register
                        </span>
                    </a> -->
                </div>
            </div>
            <div
                id="navbar-collapse"
                [class.active]="classApplied"
                class="bg-white dark:bg-black mt-[0] p-[20px] md:p-[30px] w-full hidden lg:!hidden"
            ><!-- For Resposive -->
                <ul class="navbar-nav flex-wrap">
                    <!-- <li class="my-[14px] md:my-[16px] first:mt-0 last:mb-0">
                        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            Home
                        </a>
                    </li> -->
                    <li class="my-[14px] md:my-[16px] first:mt-0 last:mb-0">
                        <a (click)="smoothScroll('about-us')" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            About Us
                        </a>
                    </li>
                    <li class="my-[14px] md:my-[16px] first:mt-0 last:mb-0">
                        <a (click)="smoothScroll('mission-vision')" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            Mission & Vision
                        </a>
                    </li>
                    <li class="my-[14px] md:my-[16px] first:mt-0 last:mb-0">
                        <a (click)="smoothScroll('training-areas')" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            Training List
                        </a>
                    </li>
                    
                </ul>
                <div class="flex items-center gap-[15px] mt-[14px] md:mt-[16px]">
                    <a routerLink="/authentication" class="signin inline-block text-primary-600 lg:text-[15px] xl:text-[16px] py-[11px] px-[17px] rounded-md transition-all font-medium border border-primary-600 hover:text-white hover:bg-primary-500 hover:border-primary-500">
                        <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                            <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-[24px]">
                                login
                            </i>
                            Sign in
                        </span>
                    </a>
                    <!-- <a routerLink="/authentication/sign-up" class="inline-block lg:text-[15px] xl:text-[16px] py-[11px] px-[17px] bg-purple-600 text-white rounded-md transition-all font-medium border border-purple-600 hover:bg-purple-500 hover:border-purple-500">
                        <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                            <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-[24px]">
                                person
                            </i>
                            Register
                        </span>
                    </a> -->
                </div>
            </div>
        </div>
    </div>
</div>